import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_ESENCIAL } from '../lib/links';
import { trackPixelEvent } from '../lib/metaPixel';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-158" data-mp="1v9xmdwibr6p5">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-forest/12 bg-cream-card/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-159" data-mp="1hh815uame5t3">
          <div className="flex items-center gap-3" data-id="element-160" data-mp="2dzm3omt96om1">
            <div className="min-w-0 flex-1" data-id="element-161" data-mp="3fb89j2dmkrre">
              <p className="truncate text-xs text-forest-dark/55" data-id="element-162" data-mp="3fc17bdulw6xe">
                Mega Pack · 3 Tomos + 6 Bonos
              </p>
              <p className="font-display text-lg font-semibold text-forest-dark" data-id="element-163" data-mp="3p1krqnxyw8ud">
                $19.990 ARS
              </p>
            </div>
            <a href={CHECKOUT_ESENCIAL} target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: 'Mega Pack Esencial',
          value: 19990,
          currency: 'ARS'
        })} className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-forest px-5 py-3 text-sm font-semibold text-cream transition-colors hover:bg-forest-dark" data-id="element-164" data-mp="3ka2otucdvy6r">
              Comprar
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-165" data-mp="28nuiz3vwkwee" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}